import React, { useEffect } from "react";
import { useState } from "react";
import axios from "axios";
import Gateway from "./Gateway";


export const Sitesettings = () => {

  const [WebTitle, setWebTitle] = useState("");
  const [WebsiteName, setWebName] = useState("");
  const [CompanyName, setCompanyName] = useState("");
  const [CompanyAddress, setCompanyAddress] = useState("");
  const [CompanyMobile, setCompanyMobile] = useState("");
  const [CompanyEmail, setCompanyEmail] = useState("");
  const [CompanyWebsite, setCompanyWebsite] = useState("");
  const [Logo, setLogo] = useState("");
  const [SmallLogo, setSmallLogo] = useState("");

  const [LandingImage1, setLandingImage1] = useState("");
  const [LandingImage2, setLandingImage2] = useState("");
  const [LandingImage3, setLandingImage3] = useState("");
  const [LandingImage4, setLandingImage4] = useState("");

  const [isLandingImage1, issetLandingImage1] = useState(true);
  const [isLandingImage2, issetLandingImage2] = useState(true);
  const [isLandingImage3, issetLandingImage3] = useState(true);
  const [isLandingImage4, issetLandingImage4] = useState(true);

  const [version, setVersion] = useState("");
  const [NoticeText, setNoticeText] = useState("");
  const [HomepageNotice1, setHomepageNotice1] = useState("");
  const [HomepageNotice2, setHomepageNotice2] = useState("");
  const [isNoticeText, setIsNoticeText] = useState(true);
  const [isHomepageNotice1, setIsHomepageNotice1] = useState(true);
  const [isHomepageNotice2, setIsHomepageNotice2] = useState(true);
  const [isMaintenance, setIsMaintenance] = useState(false);
  const [totalCommission, setTotalCommission] = useState(5);
  const [referralCommission, setReferralCommission] = useState(2);
  const [isReferralCommission, setIsReferralCommission] = useState(true);

  const [settingId, setSettingId] = useState("");

  const backendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  const backendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API;
  const nodeMode = process.env.NODE_ENV;
  if (nodeMode === "development") {
    var baseUrl = backendLocalApiUrl;
  } else {
    baseUrl = backendLiveApiUrl;
  }

  useEffect(() => {
    const data = axios.get(baseUrl + "settings/admin-data", {}).then((res) => {
      if (res.data) {
        setSettingId((res.data._id) ? res.data._id : '');
        setWebTitle(res.data.WebTitle || "");
        setWebName(res.data.WebsiteName || "");
        setCompanyName(res.data.CompanyName || "");
        setCompanyAddress(res.data.CompanyAddress || "");
        setCompanyMobile(res.data.CompanyMobile || "");
        setCompanyEmail(res.data.CompanyEmail || "");
        setCompanyWebsite(res.data.CompanyWebsite || "");
        setLogo(res.data.Logo || "");
        setSmallLogo(res.data.SmallLogo || "");
        setLandingImage1(res.data.LandingImage1 || "");
        setLandingImage2(res.data.LandingImage2 || "");
        setLandingImage3(res.data.LandingImage3 || "");
        setLandingImage4(res.data.LandingImage4 || "");
        issetLandingImage1(res.data.isLandingImage1 !== undefined ? res.data.isLandingImage1 : true);
        issetLandingImage2(res.data.isLandingImage2 !== undefined ? res.data.isLandingImage2 : true);
        issetLandingImage3(res.data.isLandingImage3 !== undefined ? res.data.isLandingImage3 : true);
        issetLandingImage4(res.data.isLandingImage4 !== undefined ? res.data.isLandingImage4 : true);
        setVersion(res.data.version || "");
        setNoticeText(res.data.NoticeText || "");
        setHomepageNotice1(res.data.HomepageNotice1 || "अगर कोई ऑटो छोड़ता है तो उसके पेनल्टी लगाई जाएगी Instant withdrawal 24x7 Support");
        setHomepageNotice2(res.data.HomepageNotice2 || "Loss होने पर रिजल्ट डाल नही दी तो पेनल्टी लगाई जाएगी Instant Withdraw");
        setIsNoticeText(res.data.isNoticeText !== undefined ? res.data.isNoticeText : true);
        setIsHomepageNotice1(res.data.isHomepageNotice1 !== undefined ? res.data.isHomepageNotice1 : true);
        setIsHomepageNotice2(res.data.isHomepageNotice2 !== undefined ? res.data.isHomepageNotice2 : true);
        setIsMaintenance(res.data.isMaintenance !== undefined ? res.data.isMaintenance : false);
        setTotalCommission(res.data.totalCommission !== undefined ? res.data.totalCommission : 5);
        setReferralCommission(res.data.referralCommission !== undefined ? res.data.referralCommission : 2);
        setIsReferralCommission(res.data.isReferralCommission !== undefined ? res.data.isReferralCommission : true);
      }
    }).catch(err => console.error(err));
  }, []);
  const handleSubmit = async (e) => {
    e.preventDefault();
    let formData = new FormData();
    formData.append("settingId", settingId);
    formData.append("WebTitle", WebTitle);
    formData.append("WebsiteName", WebsiteName);
    formData.append("CompanyName", CompanyName);
    formData.append("CompanyAddress", CompanyAddress);
    formData.append("CompanyMobile", CompanyMobile);
    formData.append("CompanyEmail", CompanyEmail);
    formData.append("CompanyWebsite", CompanyWebsite);
    formData.append("Logo", Logo);
    formData.append("SmallLogo", SmallLogo);
    formData.append("LandingImage1", LandingImage1);
    formData.append("LandingImage2", LandingImage2);
    formData.append("LandingImage3", LandingImage3);
    formData.append("LandingImage4", LandingImage4);
    formData.append("isLandingImage1", isLandingImage1);
    formData.append("isLandingImage2", isLandingImage2);
    formData.append("isLandingImage3", isLandingImage3);
    formData.append("isLandingImage4", isLandingImage4);
    formData.append("version", version);
    formData.append("NoticeText", NoticeText);
    formData.append("HomepageNotice1", HomepageNotice1);
    formData.append("HomepageNotice2", HomepageNotice2);
    formData.append("isNoticeText", isNoticeText);
    formData.append("isHomepageNotice1", isHomepageNotice1);
    formData.append("isHomepageNotice2", isHomepageNotice2);
    formData.append("isMaintenance", isMaintenance);
    formData.append("totalCommission", totalCommission);
    formData.append("referralCommission", referralCommission);
    formData.append("isReferralCommission", isReferralCommission);
    const response = await axios.post(
      baseUrl + `settings`,
      formData
    );
    if(response.data.status==='success'){
      alert("Settings submitted successfully");
    }else{
      alert("Settings Not Submitted");
    }
  };
  useEffect(() => {
    const Logo1 = document.getElementById("Logo");
    const Logo2 = document.getElementById("SmallLogo");
    const LandingImage1 = document.getElementById("LandingImage1");
    const LandingImage2 = document.getElementById("LandingImage2");
    const LandingImage3 = document.getElementById("LandingImage3");
    const LandingImage4 = document.getElementById("LandingImage4");

    Logo1.onchange = (e) => {
      const [file] = Logo1.files;
      setLogo(file);
    };
    Logo2.onchange = (e) => {
      const [file] = Logo2.files;
      setSmallLogo(file);
    };
    LandingImage1.onchange = (e) => {
      const [file] = LandingImage1.files;
      setLandingImage1(file);
    };
    LandingImage2.onchange = (e) => {
      const [file] = LandingImage2.files;
      setLandingImage2(file);
    };
    LandingImage3.onchange = (e) => {
      const [file] = LandingImage3.files;
      setLandingImage3(file);
    };
    LandingImage4.onchange = (e) => {
      const [file] = LandingImage4.files;
      setLandingImage4(file);
    };
  }, []);
  return (
    <>
      <h3 className="text-uppercase font-weight-bold my-3 text-white">Website Settings</h3>

      <h4 className="text-uppercase font-weight-bold my-3 text-light" >UI Settings</h4>
      <form
        onSubmit={handleSubmit}
        method="patch"
        encType="multipart/form-data"
        style={{backgroundColor:"rgba(0, 27, 11, 0.734)"}}
      >
        <div className="form-row">
          <div className="form-group col-md-4">

            <label htmlFor="WebsiteName">Website Title</label>
            <input
              className="form-control"
              type="text"
              value={WebTitle}
              onChange={(e) => setWebTitle(e.target.value)}
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group col-md-4">
            <label htmlFor="NoticeText">Announcement Text (For Website)</label>
            <textarea
              className="form-control"
              value={NoticeText}
              onChange={(e) => setNoticeText(e.target.value)}
              placeholder="e.g. Website is undergoing update..."
            />
            <select 
              className="form-control mt-2" 
              value={String(isNoticeText)} 
              onChange={(e) => setIsNoticeText(e.target.value === 'true')}
            >
              <option value="true">On</option>
              <option value="false">Off</option>
            </select>
          </div>

          <div className="form-group col-md-4">
            <label htmlFor="HomepageNotice1">Homepage Alert 1</label>
            <textarea
              className="form-control"
              value={HomepageNotice1}
              onChange={(e) => setHomepageNotice1(e.target.value)}
            />
            <select 
              className="form-control mt-2" 
              value={String(isHomepageNotice1)} 
              onChange={(e) => setIsHomepageNotice1(e.target.value === 'true')}
            >
              <option value="true">On</option>
              <option value="false">Off</option>
            </select>
          </div>

          <div className="form-group col-md-4">
            <label htmlFor="HomepageNotice2">Homepage Alert 2</label>
            <textarea
              className="form-control"
              value={HomepageNotice2}
              onChange={(e) => setHomepageNotice2(e.target.value)}
            />
            <select 
              className="form-control mt-2" 
              value={String(isHomepageNotice2)} 
              onChange={(e) => setIsHomepageNotice2(e.target.value === 'true')}
            >
              <option value="true">On</option>
              <option value="false">Off</option>
            </select>
          </div>
        </div>

        <div className="form-row">
          <div className="form-group col-md-4">
            <label>Turn On 404/Maintenance Mode</label>
            <select
              className="form-control"
              value={String(isMaintenance)}
              onChange={(e) => setIsMaintenance(e.target.value)}
            >
              <option value="false">Off</option>
              <option value="true">On</option>
            </select>
          </div>

          <div className="form-group col-md-4">
            <label htmlFor="totalCommission">Total Commission (%)</label>
            <input
              type="number"
              className="form-control"
              value={totalCommission}
              onChange={(e) => setTotalCommission(e.target.value)}
            />
          </div>

          <div className="form-group col-md-4">
            <label htmlFor="referralCommission">Referral Commission (%)</label>
            <input
              type="number"
              className="form-control"
              value={referralCommission}
              onChange={(e) => setReferralCommission(e.target.value)}
            />
            <select 
              className="form-control mt-2" 
              value={String(isReferralCommission)} 
              onChange={(e) => setIsReferralCommission(e.target.value === 'true')}
            >
              <option value="true">On</option>
              <option value="false">Off</option>
            </select>
          </div>
        </div>

        <div className="form-row">
          <div className="form-group col-md-4">

            <label htmlFor="WebsiteName">Website Name</label>
            <input
              className="form-control"
              type="text"
              value={WebsiteName}
              onChange={(e) => setWebName(e.target.value)}
            />
          </div>
        </div>
        
        <div className="form-row">
          <div className="form-group col-md-4">
            <label htmlFor="WebsiteName">Company Name</label>
            <input
              className="form-control"
              type="text"
              value={CompanyName}
              onChange={(e) => setCompanyName(e.target.value)}
            />
          </div>
        
          <div className="form-group col-md-4">
            <label htmlFor="WebsiteName">Company Address</label>
            <input
              className="form-control"
              type="text"
              value={CompanyAddress}
              onChange={(e) => setCompanyAddress(e.target.value)}
            />
          </div>
        
          <div className="form-group col-md-4">
            <label htmlFor="WebsiteName">Company Mobile</label>
            <input
              className="form-control"
              type="text"
              value={CompanyMobile}
              onChange={(e) => setCompanyMobile(e.target.value)}
            />
          </div>
        
          <div className="form-group col-md-4">
            <label htmlFor="WebsiteEmail">Company Email</label>
            <input
              className="form-control"
              type="text"
              value={CompanyEmail}
              onChange={(e) => setCompanyEmail(e.target.value)}
            />
          </div>
        
          <div className="form-group col-md-4">
            <label htmlFor="WebsiteWebsite">Company Website</label>
            <input
              className="form-control"
              type="text"
              value={CompanyWebsite}
              onChange={(e) => setCompanyWebsite(e.target.value)}
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group col-md-4">

            <label htmlFor="WebsiteName">Right Logo</label>
            <input className="form-control" type="file" name="Logo" id="Logo"  />
          </div>

          <div className="form-group col-md-4">
            <label htmlFor="WebsiteName">Left Logo</label>
            <input className="form-control" type="file" name="SmallLogo" id="SmallLogo"  />

          </div>

        </div>

        <div className="form-row">
          <div className="form-group col-md-4">
            <label htmlFor="LandingImage1">Game image (1)</label>
            <input className="form-control" type="file" name="LandingImage1" id="LandingImage1" />
            <select className="form-control mt-2" value={String(isLandingImage1)} onChange={(e) => issetLandingImage1(e.target.value)}>
              <option value="true">On</option>
              <option value="false">Off</option>
            </select>
          </div>

          <div className="form-group col-md-4">
            <label htmlFor="LandingImage2">Game image (2)</label>
            <input className="form-control" type="file" name="LandingImage2" id="LandingImage2" />
            <select className="form-control mt-2" value={String(isLandingImage2)} onChange={(e) => issetLandingImage2(e.target.value)}>
              <option value="true">On</option>
              <option value="false">Off</option>
            </select>
          </div>

          <div className="form-group col-md-4">
            <label htmlFor="LandingImage3">Game image (3)</label>
            <input className="form-control" type="file" name="LandingImage3" id="LandingImage3" />
            <select className="form-control mt-2" value={String(isLandingImage3)} onChange={(e) => issetLandingImage3(e.target.value)}>
              <option value="true">On</option>
              <option value="false">Off</option>
            </select>
          </div>

          <div className="form-group col-md-4">
            <label htmlFor="LandingImage4">Support Image (4)</label>
            <input className="form-control" type="file" name="LandingImage4" id="LandingImage4" />
            <select className="form-control mt-2" value={String(isLandingImage4)} onChange={(e) => issetLandingImage4(e.target.value)}>
              <option value="true">On</option>
              <option value="false">Off</option>
            </select>
          </div>
        </div>


        <div className="form-row">
          <div className="form-group col-md-4">

            <label htmlFor="WebsiteName">version</label>

            <input
              className="form-control"
              type="text"
              value={version}
              onChange={(e) => setVersion(e.target.value)}
            />
          </div>


        </div>

        <div className="form-row">
          <div className="form-group col-md-4">
            <button type="submit" className="btn btn-primary">
              Update Settings
            </button>
          </div>
        </div>



      </form>
      <Gateway />
    </>
  );
};
